import React from "react";

import { OverflowTooltip } from "components";

import styles from "../matchReport.module.scss";

const numberOfFieldsMatched = () => ({
	Header: "Number of Fields Matched",
	accessor: "matched_fields_length",
	classNameHeader: `${styles.tableHeader}`,
	Cell({ value }: { value: number }) {
		return (
			<OverflowTooltip onlyOnLaptop title={value}>
				{value}
			</OverflowTooltip>
		);
	},
});

export default numberOfFieldsMatched;
